var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query, queryAssignedElements } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { uniqueId } from 'lodash-es';
import { appendStylesToTheStyleRoot } from '../utilities/dom';
import stylesGlobal from './_sds-switcher-global.lit.scss';
import { SdsSwitcherItem } from './sds-switcher-item.lit';
import styles from './sds-switcher.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Control that represents a switcher group.
 *
 * @slot - This is where underlying switchers are inserted.
 * Only `sds-switcher` components must be injected here other components will be ignored by this one.
 *
 * @fires sds.switcher.changed - Event is being dispatched when selected switcher is changed in this group.
 * Event is of `CustomEvent` type with details of `{selected: string}` type.
 */
let SdsSwitcher = (() => {
    var _SdsSwitcher_selected_accessor_storage, _SdsSwitcher_small_accessor_storage, _SdsSwitcher__switchers_accessor_storage, _SdsSwitcher_slotElement_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-switcher')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _small_decorators;
    let _small_initializers = [];
    let _small_extraInitializers = [];
    let __switchers_decorators;
    let __switchers_initializers = [];
    let __switchers_extraInitializers = [];
    let _slotElement_decorators;
    let _slotElement_initializers = [];
    let _slotElement_extraInitializers = [];
    var SdsSwitcher = _classThis = class extends _classSuper {
        /**
         * This attribute holds selected value.
         * @attr
         */
        get selected() { return __classPrivateFieldGet(this, _SdsSwitcher_selected_accessor_storage, "f"); }
        set selected(value) { __classPrivateFieldSet(this, _SdsSwitcher_selected_accessor_storage, value, "f"); }
        /**
         * This attribute represents a alignment of underlying switchers.
         * @attr
         */
        get small() { return __classPrivateFieldGet(this, _SdsSwitcher_small_accessor_storage, "f"); }
        set small(value) { __classPrivateFieldSet(this, _SdsSwitcher_small_accessor_storage, value, "f"); }
        get _switchers() { return __classPrivateFieldGet(this, _SdsSwitcher__switchers_accessor_storage, "f"); }
        set _switchers(value) { __classPrivateFieldSet(this, _SdsSwitcher__switchers_accessor_storage, value, "f"); }
        get slotElement() { return __classPrivateFieldGet(this, _SdsSwitcher_slotElement_accessor_storage, "f"); }
        set slotElement(value) { __classPrivateFieldSet(this, _SdsSwitcher_slotElement_accessor_storage, value, "f"); }
        connectedCallback() {
            super.connectedCallback();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
        }
        updated() {
            this.updateSwitcherButtons();
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-switcher', this._stylesGlobal.cssText);
            return html `
            <div class="${this.getClasses()}">
                <slot @slotchange="${() => this.handleSlotChange()}"></slot>
            </div>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        prepareChildren() {
            this._switchers.forEach(switcher => {
                if (switcher instanceof SdsSwitcherItem) {
                    switcher.name = this._groupName;
                    switcher.addEventListener(SdsSwitcherItem.CHANGED_EVENT, e => this.handleChanged(e));
                }
                else {
                    console.error('One of the children of the switcher group was not of switcher type -> %o', switcher);
                }
            });
        }
        handleSlotChange() {
            this.prepareChildren();
            const slottedElements = this.slotElement.assignedNodes({ flatten: true });
            const itemsWithLabel = slottedElements.filter(element => element instanceof SdsSwitcherItem &&
                element.label !== undefined &&
                element.label.trim() !== '');
            // Calculate the percentage width
            const itemWidthPercentage = 100 / itemsWithLabel.length;
            // Apply the width to each sds-switcher-item with label
            itemsWithLabel.forEach(switcher => {
                if (switcher instanceof SdsSwitcherItem) {
                    switcher.style.width = `${itemWidthPercentage}%`;
                }
            });
        }
        updateSwitcherButtons() {
            for (const switcher of this._switchers) {
                switcher.checked = switcher.value === this.selected;
            }
        }
        handleChanged(event) {
            this.selected = event.target.value;
            this.updateSwitcherButtons();
            this.dispatchEvent(new CustomEvent(SdsSwitcher.CHANGED_EVENT, {
                detail: { selected: this.selected },
                bubbles: false,
                composed: false,
            }));
        }
        getClasses() {
            return classMap({
                'sds-switcher': true,
            });
        }
        constructor() {
            super(...arguments);
            _SdsSwitcher_selected_accessor_storage.set(this, __runInitializers(this, _selected_initializers, void 0));
            _SdsSwitcher_small_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _small_initializers, void 0)));
            this._stylesGlobal = (__runInitializers(this, _small_extraInitializers), stylesGlobal);
            _SdsSwitcher__switchers_accessor_storage.set(this, __runInitializers(this, __switchers_initializers, void 0));
            this._groupName = (__runInitializers(this, __switchers_extraInitializers), uniqueId('sds-switcher'));
            _SdsSwitcher_slotElement_accessor_storage.set(this, __runInitializers(this, _slotElement_initializers, void 0));
            __runInitializers(this, _slotElement_extraInitializers);
        }
    };
    _SdsSwitcher_selected_accessor_storage = new WeakMap();
    _SdsSwitcher_small_accessor_storage = new WeakMap();
    _SdsSwitcher__switchers_accessor_storage = new WeakMap();
    _SdsSwitcher_slotElement_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSwitcher");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _selected_decorators = [property({ type: String, reflect: true })];
        _small_decorators = [property({ type: Boolean })];
        __switchers_decorators = [queryAssignedElements({
                selector: 'sds-switcher-item',
            })];
        _slotElement_decorators = [query('slot')];
        __esDecorate(_classThis, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
        __esDecorate(_classThis, null, _small_decorators, { kind: "accessor", name: "small", static: false, private: false, access: { has: obj => "small" in obj, get: obj => obj.small, set: (obj, value) => { obj.small = value; } }, metadata: _metadata }, _small_initializers, _small_extraInitializers);
        __esDecorate(_classThis, null, __switchers_decorators, { kind: "accessor", name: "_switchers", static: false, private: false, access: { has: obj => "_switchers" in obj, get: obj => obj._switchers, set: (obj, value) => { obj._switchers = value; } }, metadata: _metadata }, __switchers_initializers, __switchers_extraInitializers);
        __esDecorate(_classThis, null, _slotElement_decorators, { kind: "accessor", name: "slotElement", static: false, private: false, access: { has: obj => "slotElement" in obj, get: obj => obj.slotElement, set: (obj, value) => { obj.slotElement = value; } }, metadata: _metadata }, _slotElement_initializers, _slotElement_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSwitcher = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGED_EVENT = 'sds.switcher.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSwitcher = _classThis;
})();
export { SdsSwitcher };
